import { useState, useCallback } from "react";
import { GSTDeterminationEntity } from "../../domain/entities/TaxEntity";
import { taxRepository } from "../../data/repositories/TaxRepositoryImpl";

export interface UseGSTDeterminationReturn {
  gstDetermination: GSTDeterminationEntity | null;
  loading: boolean;
  error: string | null;
  determineGSTType: (
    invoiceData: any
  ) => Promise<GSTDeterminationEntity | null>;
  clearError: () => void;
}

export const useGSTDetermination = (): UseGSTDeterminationReturn => {
  const [gstDetermination, setGstDetermination] =
    useState<GSTDeterminationEntity | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const determineGSTType = useCallback(
    async (invoiceData: any): Promise<GSTDeterminationEntity | null> => {
      setLoading(true);
      setError(null);
      try {
        const result = await taxRepository.fetchGSTTypeDetermination(
          invoiceData
        );
        if (result.success) {
          setGstDetermination(result);
          return result;
        } else {
          setError("Failed to determine GST type");
          return null;
        }
      } catch (err: any) {
        setError(err.message || "An error occurred while determining GST type");
        console.error("Error determining GST type:", err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    gstDetermination,
    loading,
    error,
    determineGSTType,
    clearError,
  };
};
